__webpack_require__.p = "https://assets.yanolja.com/platform-site/prod/8d685a868852dbc624aa41d333fa0548aefc4942/_next/";